module.exports = __webpack_public_path__ + "static/CBDCmobile-9e9020c52a0a622eac03101c7f8ddf2e.png";